import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {PermissionService} from '../../../services/permission.service';
import {PermissionComponent} from '../permission.component';

@Component({
  selector: 'app-label-add-edit',
  templateUrl: './permission-add-edit.component.html',
  styleUrls: ['./permission-add-edit.component.scss']
})
export class PermissionAddEditComponent {

  permissionForm: FormGroup;
  saving = false;

  public data: any;

  isSubmitted = false;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef;

  @ViewChild(PermissionComponent) permsComponent : PermissionComponent;

  constructor(private fb: FormBuilder,
              private permissionService: PermissionService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    this.permissionForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      isEnable: '',
    });

  }

  ngOnInit() {
    this.permissionForm.get('isEnable')?.setValue('1');
    this.permissionForm.patchValue(this.data);
    this.permissionForm.get('isEnable')?.setValue(this.data.isEnable ? '1' : '0');
  }

  get fc(): any {
    return this.permissionForm.controls;
  }

  onFormSubmit(): any {
    this.isSubmitted = true;
    if (this.permissionForm.valid){
      this.saving = true;
      if (this.data){
        this.permissionForm.get('isEnable')?.setValue(this.permissionForm.get('isEnable')?.value === '1');
        this.permissionService.put(this.data.id, this.permissionForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Permission edit with success !', 'Success');
            this.activeModal.close();
            //this.permissionForm.reset();

            //this.permissionService.refreshPermissions();

          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            const errors: any[] = err.error.violations;

            errors.forEach((v) =>
            {
              if (v.propertyPath === 'name'){
                this.permissionForm.get('name')?.setErrors({serverError: v.message});
              }
              this.saving = false;

            });
          }
        });
      }
      else {
        this.permissionForm.get('isEnable')?.setValue(this.permissionForm.get('isEnable')?.value === '1');
        this.permissionService.post(this.permissionForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Permission create with success !', 'Success');
            // this.activeModal.close();
            this.permissionForm.reset({ value: this.permissionForm.value, emitEvent: false });
            // this.permissionForm.removeControl('name', { emitEvent: false })
            this.permissionService.refreshPermissions();

          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            const errors: any[] = err.violations;
            console.log(errors);

            errors.forEach((v) =>
            {
              if (v.propertyPath === 'name'){
                this.permissionForm.get('name')?.setErrors({serverError: v.message});
              }
              this.saving = false;
            });
          }
        });


      }

    }

    else {
      // Si le formulaire est invalide, marquez-le comme non soumis
      // pour empêcher les messages de validation de s'afficher immédiatement
      this.isSubmitted = false;
      this.saving = false;
    }

  }


}
